export enum ButtonVariants {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  LIGHT_BLUE = "lightBlue",
  OPACITY_GRAY = "opacityGray",
  GREEN = "green",

  OPACITY_SECONDARY = "opacitySecondary",
}
